import { DEFAULT_AEM_PARAMS } from '../tracking/trackingData';
import {
  CONFIG_FRONTEND_BASE_URL,
  CONFIG_DUW_BASE_URL,
  CONFIG_DUW_ENTRYPOINT_FILE,
  CONFIG_PERSONENDATENERFASSUNG_BASE_URL,
  CONFIG_PERSONENDATENERFASSUNG_ENTRYPOINT_FILE,
} from '../config';
import { AemCarbonEnv, CarbonParamName } from '../types/AemCarbonEnv';

interface ServiceConfiguration {
  duw: Service;
  pde: Service;
  iconsPath: string;
  fragmentPath: string;
}

interface Service {
  baseUrl: string;
  entrypointFile: string;
}

export const { params: carbonParams } = window as Window;
// eslint-disable-next-line
const aemContent = document.querySelector("[id^='rlv-otr']");
export const aemAssets = aemContent ? carbonParams[aemContent.id] : DEFAULT_AEM_PARAMS;

export const rlvKey: string | false =
  !!carbonParams && Object.keys(carbonParams).filter(k => k.includes('rlv-otr'))[0];
const carbonEnv =
  !!carbonParams &&
  !!rlvKey &&
  carbonParams[rlvKey].envs.find((env: AemCarbonEnv) => env.name === 'otrUrl');

export const getServiceConfiguration = (): ServiceConfiguration => {
  const iconsPath: string = !!carbonEnv ? carbonEnv.url : '';
  const fragmentPath: string = !!carbonEnv
    ? `${window.location.protocol}//${window.location.hostname}`
    : '';

  return {
    duw: {
      baseUrl: CONFIG_DUW_BASE_URL,
      entrypointFile: CONFIG_DUW_ENTRYPOINT_FILE,
    },
    pde: {
      baseUrl: CONFIG_PERSONENDATENERFASSUNG_BASE_URL,
      entrypointFile: CONFIG_PERSONENDATENERFASSUNG_ENTRYPOINT_FILE,
    },
    iconsPath,
    fragmentPath,
  };
};
export const isFullofferEnabled = aemAssets[CarbonParamName.VOLLANGEBOT] !== 'false';

export const getLocalDocRoutes = (offlineDocs: string[]) =>
  offlineDocs.map((doc: string) => `${CONFIG_FRONTEND_BASE_URL}/documents/${doc}`);
